import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const useExteriorSignages = () => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['exteriorSignages'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/exterior-signages');
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
  return query;
};

export const useExteriorSignage = exteriorSignageId => {
  const { errorMessage } = useToast();

  const query = useQuery({
    queryKey: ['exteriorSignage', exteriorSignageId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/exterior-signages/${exteriorSignageId}`);
      return response.data;
    },
    staleTime: 0,
    enabled: !!exteriorSignageId,
    throwOnError: errorMessage,
  });

  return query;
};
